import { SignInPage, type IdentityProviders } from '@backstage/core-components';
import {
  configApiRef,
  gitlabAuthApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

const microsoftProvider = {
  id: 'azure-auth-provider',
  title: 'Microsoft Entra ID',
  message: 'Sign in using your AD Account',
  apiRef: microsoftAuthApiRef,
};

const gitlabProvider = {
  id: 'gitlab-auth-provider',
  title: 'GitLab',
  message: 'Sign in using your GitLab Account',
  apiRef: gitlabAuthApiRef,
};

export function getSignInProviders(
  authEnvironment: string | undefined,
): IdentityProviders {
  if (authEnvironment === 'development') {
    return [microsoftProvider, 'guest', gitlabProvider];
  }
  return [microsoftProvider];
}

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const authEnvironment = useApi(configApiRef).getOptionalString(
        'auth.environment',
      );
      return (
        <SignInPage
          {...props}
          auto
          providers={getSignInProviders(authEnvironment)}
        />
      );
    },
  },
});

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
